package fr.frux.feature.onboarding

import fr.frux.core.maps.LocationPermissionStatus

/** Les deux pas de l'accueil (#502) : la promesse, puis la position. */
enum class OnboardingStep {
    PROMISE,
    LOCATION,
}

/**
 * Comment l'accueil s'est terminé. [LocationDeclined] permet à l'hôte de dire à la carte de ne
 * pas redemander la position tout de suite ni d'afficher le bandeau de refus à l'arrivée : la
 * personne vient de répondre, insister contredirait son choix.
 */
sealed interface OnboardingOutcome {
    data object Finished : OnboardingOutcome

    data object LocationDeclined : OnboardingOutcome
}

/**
 * Pas suivant après « Continuer » sur la promesse. `null` termine l'accueil : sans pas position
 * (desktop, aucun provider de position), la promesse suffit.
 */
fun nextStepAfterPromise(locationStep: Boolean): OnboardingStep? = if (locationStep) OnboardingStep.LOCATION else null

/**
 * Issue du pas position selon le statut rapporté par le contrôleur de permission. `null` tant
 * que la demande n'a pas abouti : l'écran attend.
 */
fun outcomeForLocationStatus(status: LocationPermissionStatus): OnboardingOutcome? =
    when (status) {
        LocationPermissionStatus.NOT_REQUESTED -> null

        LocationPermissionStatus.GRANTED -> OnboardingOutcome.Finished

        LocationPermissionStatus.DENIED,
        LocationPermissionStatus.PERMANENTLY_DENIED,
        -> OnboardingOutcome.LocationDeclined
    }
